/**
 * Checks if a given value can be considered a valid number.
 * This function treats null, empty strings, and non-numeric strings as invalid.
 * It correctly identifies numbers and string representations of numbers (e.g., "123") as valid.
 * @param value The value to check, which can be a string, number, or null.
 * @returns `true` if the value is a valid number, otherwise `false`.
 */
export const isValidNumber = (value: string | number | null | undefined): boolean => {
  return value != null && value !== '' && (!isNaN(Number(value)))
}

/**
 * Checks if a given value is a valid positive number (greater than or equal to 0).
 * @param value The value to check, which can be a string, number, or null.
 * @returns `true` if the value is a valid number and is greater than or equal to 0, otherwise `false`.
 */
export const isValidPositiveNumber = (value: string | number | null | undefined): boolean => {
  return isValidNumber(value) && Number(value) >= 0
}
